import { BOUNTY_TYPES } from "./bounties.constants"
import { getVideoFileSignature } from "./bounties.apis"

export const execOpWithAuth = async (operation, onError, dispatch) => {
  try {
    if (typeof operation !== "function") {
      return
    }
    return await operation()
  } catch (errors) {
    if (typeof onError === "function") {
      onError(errors)
    }

    const attemptRefresh = errors.find((error) => {
      return error.extensions.code === "SESSION_EXPIRED"
    })
    const refetchAuth = errors.find((error) => {
      return ["UNAUTHENTICATED"].includes(error.extensions.code)
    })

    if (attemptRefresh || refetchAuth) {
      await dispatch(
        "Auth/addCallbackToAimlabsAuthListenerQueue",
        () => { operation() },
        { root: true }
      )
    }

    if (attemptRefresh) {
      await dispatch("Coach/Dashboard/AimlabsMarketplace/refreshAccessToken", null, { root: true })
      await dispatch("Auth/processAimlabsAuthListenerQueue", null, { root: true })
    }

    if (refetchAuth) {
      await dispatch("Auth/beginAimLabSSO", null, { root: true })
    }
  }
}

const signVideoFile = async (fileUrl) => {
  try {
    const url = new URL(fileUrl)
    const hostname = url.hostname

    const isAimlabsVideoUrl = hostname.match(/^video(\..*)+\.aimlabs\.com$/g).length > 0
    if (isAimlabsVideoUrl) {
      const uuidMatches = url.pathname.match(/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/g)
      const pipelineId = uuidMatches[0]
      const signature = await getVideoFileSignature(pipelineId)
      signature.split("&").forEach(queryParam => {
        const queryParamPieces = queryParam.split("=")
        const key = queryParamPieces[0]
        const value = queryParamPieces[1]
        if (key !== undefined && value !== undefined) {
          url.searchParams.set(key, value)
        }
      })
    }

    return url.toString()
  } catch (e) {
    // If unable to sign, just return the input string
    return fileUrl
  }
}

// TODO: Clean up mapping and Request Preview components...
export const mapBountyToRequest = async (bounty) => {
  const signedUrl = await signVideoFile(bounty.url)

  return {
    id: bounty.id,
    preview_only: true,
    source: "aimlabs",
    student: {
      proguides_user: {
        avatar: {
          thumbnail_url: bounty.submittingUser.profileImageUrl,
        },
      },
      nickname: bounty.submittingUser.username,
    },
    game: {
      name: bounty.game.tag,
    },
    async_param: {
      commentaries: [{
        attachment: bounty.type === BOUNTY_TYPES.VOD ? signedUrl : null,
        attachment_metadata: bounty.type === BOUNTY_TYPES.VOD
          ? {
            video_duration: bounty.metadata?.duration,
          }
          : null,
        comments: bounty.value && [{
          comment: bounty.value,
        }],
      }],
    },
  }
}



// WEBPACK FOOTER //
// ./src/store/coach/dashboard/aimlabs-marketplace/bounties/bounties.utils.js